export function createExternalLinkIcon(opensInNewTabText: string): HTMLElement {
  const iconWrapper = document.createElement('div');
  const icon = document.createElement('mat-icon');

  icon.className = 'material-icons external-redirect-link-arrow';
  icon.innerHTML = 'call_made';
  icon.setAttribute('aria-hidden', 'true');
  iconWrapper.className = 'external-redirect-link-arrow-wrapper';
  const label = document.createElement('span');
  label.className = 'cdk-visually-hidden';
  label.textContent = ` ${opensInNewTabText}`;
  iconWrapper.appendChild(icon);
  iconWrapper.appendChild(label);

  return iconWrapper;
}
